import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/no-data.png'


const _hoisted_1 = { class: "billing--container ma--top-1" }
const _hoisted_2 = {
  key: 0,
  class: "loading"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "loading-pulse" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "row ma--bottom-1"
}
const _hoisted_6 = { class: "col-xl-12" }
const _hoisted_7 = { class: "card" }
const _hoisted_8 = { class: "card-header" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-shopping-cart btn--icon__prefix" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "btn--name" }, "Buy Credits", -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "btn--name" }, "Refunds", -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "card-content" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "ma-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "color--tertiary-blue text--weight-bold" }, "Credit Purchased Receipts")
], -1)
const _hoisted_16 = { class: "table table--striped" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-left" }, " Receipt "),
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-center" }, [
      /*#__PURE__*/_createTextVNode(" Date "),
      /*#__PURE__*/_createElementVNode("div", {
        class: "info right",
        "data-tooltip": "The date credits were purchased."
      }, [
        /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle" })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-center" }, [
      /*#__PURE__*/_createTextVNode(" Credits Purchased "),
      /*#__PURE__*/_createElementVNode("div", {
        class: "info",
        "data-tooltip": "The number of credits purchased."
      }, [
        /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle" })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-center" }, [
      /*#__PURE__*/_createTextVNode(" Amount Spent "),
      /*#__PURE__*/_createElementVNode("div", {
        class: "info left",
        "data-tooltip": "The dollar amount spent on credits."
      }, [
        /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle" })
      ])
    ])
  ])
], -1)
const _hoisted_18 = { class: "text--align-left" }
const _hoisted_19 = ["href"]
const _hoisted_20 = { class: "text--align-center" }
const _hoisted_21 = { class: "text--align-center" }
const _hoisted_22 = { class: "text--align-center" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("td", { colspan: "3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "table__body--empty" }, [
    /*#__PURE__*/_createElementVNode("div", null, "No data to display"),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "No Data"
    })
  ])
], -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", { class: "ma-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "color--tertiary-blue text--weight-bold" }, "Subscription Invoiced Receipts")
], -1)
const _hoisted_27 = { class: "table table--striped" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-left" }, " Receipt "),
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-center" }, [
      /*#__PURE__*/_createTextVNode(" Date "),
      /*#__PURE__*/_createElementVNode("div", {
        class: "info right",
        "data-tooltip": "The date credits were purchased."
      }, [
        /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle" })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-center" }, [
      /*#__PURE__*/_createTextVNode(" Credits Purchased "),
      /*#__PURE__*/_createElementVNode("div", {
        class: "info",
        "data-tooltip": "The number of credits purchased."
      }, [
        /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle" })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-center" }, [
      /*#__PURE__*/_createTextVNode(" Amount Spent "),
      /*#__PURE__*/_createElementVNode("div", {
        class: "info left",
        "data-tooltip": "The dollar amount spent on credits."
      }, [
        /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle" })
      ])
    ])
  ])
], -1)
const _hoisted_29 = { class: "text--align-left" }
const _hoisted_30 = ["href"]
const _hoisted_31 = { class: "text--align-center" }
const _hoisted_32 = { class: "text--align-center" }
const _hoisted_33 = { class: "text--align-center" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("td", { colspan: "3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "table__body--empty" }, [
    /*#__PURE__*/_createElementVNode("div", null, "No data to display"),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "No Data"
    })
  ])
], -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("p", { class: "ma-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "color--tertiary-blue text--weight-bold" }, "Subscription Additional Credit Receipts")
], -1)
const _hoisted_38 = { class: "table table--striped" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-left" }, " Receipt "),
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-center" }, [
      /*#__PURE__*/_createTextVNode(" Date "),
      /*#__PURE__*/_createElementVNode("div", {
        class: "info right",
        "data-tooltip": "The date credits were purchased."
      }, [
        /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle" })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-center" }, [
      /*#__PURE__*/_createTextVNode(" Credits Purchased "),
      /*#__PURE__*/_createElementVNode("div", {
        class: "info",
        "data-tooltip": "The number of credits purchased."
      }, [
        /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle" })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-center" }, [
      /*#__PURE__*/_createTextVNode(" Amount Spent "),
      /*#__PURE__*/_createElementVNode("div", {
        class: "info left",
        "data-tooltip": "The dollar amount spent on credits."
      }, [
        /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle" })
      ])
    ])
  ])
], -1)
const _hoisted_40 = { class: "text--align-left" }
const _hoisted_41 = ["href"]
const _hoisted_42 = { class: "text--align-center" }
const _hoisted_43 = { class: "text--align-center" }
const _hoisted_44 = { class: "text--align-center" }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("td", { colspan: "3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "table__body--empty" }, [
    /*#__PURE__*/_createElementVNode("div", null, "No data to display"),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "No Data"
    })
  ])
], -1)
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = /*#__PURE__*/_createElementVNode("p", { class: "ma-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "color--tertiary-blue text--weight-bold" }, "Leads Purchased Receipts")
], -1)
const _hoisted_49 = { class: "table table--striped" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-left" }, " Receipt "),
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-center" }, [
      /*#__PURE__*/_createTextVNode(" Date "),
      /*#__PURE__*/_createElementVNode("div", {
        class: "info right",
        "data-tooltip": "The date leads were purchased."
      }, [
        /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle" })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-center" }, [
      /*#__PURE__*/_createTextVNode(" No of Uniques "),
      /*#__PURE__*/_createElementVNode("div", {
        class: "info",
        "data-tooltip": "The number of uniques returned."
      }, [
        /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle" })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-center" }, [
      /*#__PURE__*/_createTextVNode(" Credit Used "),
      /*#__PURE__*/_createElementVNode("div", {
        class: "info left",
        "data-tooltip": "The number of credits used."
      }, [
        /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle" })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-left" }, [
      /*#__PURE__*/_createTextVNode(" Action "),
      /*#__PURE__*/_createElementVNode("div", {
        class: "info left",
        "data-tooltip": "Action"
      }, [
        /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle" })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-left" }, " Type ")
  ])
], -1)
const _hoisted_51 = { class: "text--align-left" }
const _hoisted_52 = ["onClick", "href"]
const _hoisted_53 = { class: "text--align-center" }
const _hoisted_54 = { class: "text--align-center" }
const _hoisted_55 = { class: "text--align-center" }
const _hoisted_56 = { class: "text--align-center" }
const _hoisted_57 = ["onClick"]
const _hoisted_58 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-download btn--icon__prefix" }, null, -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("span", { class: "btn--name" }, "Download", -1)
const _hoisted_60 = [
  _hoisted_58,
  _hoisted_59
]
const _hoisted_61 = { class: "text--align-left" }
const _hoisted_62 = { key: 0 }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("td", { colspan: "3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "table__body--empty" }, [
    /*#__PURE__*/_createElementVNode("div", null, "No data to display"),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "No Data"
    })
  ])
], -1)
const _hoisted_64 = [
  _hoisted_63
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PurchaseCredits = _resolveComponent("PurchaseCredits")!
  const _component_OpenRefund = _resolveComponent("OpenRefund")!
  const _component_PrintLeadsReceipt = _resolveComponent("PrintLeadsReceipt")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  class: "btn btn--primary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.togglePurchaseCreditModel = true))
                }, _hoisted_11),
                _createElementVNode("button", {
                  class: "btn btn--secondary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleOpenRefund = true))
                }, _hoisted_13)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("table", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.response, (item, index) => {
                      return _withDirectives((_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", _hoisted_18, [
                          _createElementVNode("a", {
                            href: '/receipt/' + item.id,
                            target: "_blank"
                          }, "Receipt-" + _toDisplayString(item.id), 9, _hoisted_19)
                        ]),
                        _createElementVNode("td", _hoisted_20, _toDisplayString(item.purchasedDate), 1),
                        _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.$filters.numberDisplay(item.credits)), 1),
                        _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.$filters.numberDisplay(item.amount, 2, 2, "$")), 1)
                      ])), [
                        [_vShow, item.type !== 'SUBSCRIPTION_ADDITIONAL_CREDIT_SUCCESS' && item.type !== 'SUBSCRIPTION_CREDIT_SUCCESS']
                      ])
                    }), 128)),
                    (_ctx.response.length == 0 && !_ctx.loading)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_23, _hoisted_25))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _hoisted_26,
                _createElementVNode("table", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subscriptionResponse, (item, index) => {
                      return _withDirectives((_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", _hoisted_29, [
                          _createElementVNode("a", {
                            href: '/receipt/' + item.id,
                            target: "_blank"
                          }, "SubscriptionReceipt-" + _toDisplayString(item.id), 9, _hoisted_30)
                        ]),
                        _createElementVNode("td", _hoisted_31, _toDisplayString(item.purchasedDate), 1),
                        _createElementVNode("td", _hoisted_32, _toDisplayString(_ctx.$filters.numberDisplay(item.credits)), 1),
                        _createElementVNode("td", _hoisted_33, _toDisplayString(_ctx.$filters.numberDisplay(item.amount, 2, 2, "$")), 1)
                      ])), [
                        [_vShow, item.type === 'SUBSCRIPTION_CREDIT_SUCCESS']
                      ])
                    }), 128)),
                    (_ctx.response.length == 0 && !_ctx.loading)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_34, _hoisted_36))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _hoisted_37,
                _createElementVNode("table", _hoisted_38, [
                  _hoisted_39,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subscriptionResponse, (item, index) => {
                      return _withDirectives((_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", _hoisted_40, [
                          _createElementVNode("a", {
                            href: '/receipt/' + item.id,
                            target: "_blank"
                          }, "SubscriptionAdditionalCreditsReceipt-" + _toDisplayString(item.id), 9, _hoisted_41)
                        ]),
                        _createElementVNode("td", _hoisted_42, _toDisplayString(item.purchasedDate), 1),
                        _createElementVNode("td", _hoisted_43, _toDisplayString(_ctx.$filters.numberDisplay(item.credits)), 1),
                        _createElementVNode("td", _hoisted_44, _toDisplayString(_ctx.$filters.numberDisplay(item.amount, 2, 2, "$")), 1)
                      ])), [
                        [_vShow, item.type === 'SUBSCRIPTION_ADDITIONAL_CREDIT_SUCCESS']
                      ])
                    }), 128)),
                    (_ctx.response.length == 0 && !_ctx.loading)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_45, _hoisted_47))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _hoisted_48,
                _createElementVNode("table", _hoisted_49, [
                  _hoisted_50,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.leadsResponse.data, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", _hoisted_51, [
                          _createElementVNode("a", {
                            onClick: _withModifiers(($event: any) => (_ctx.openLeadsReceiptPrint(item.orderId)), ["prevent"]),
                            href: _ctx.leadReceiptLink + item.orderId
                          }, "LeadsReceipt-" + _toDisplayString(item.orderId), 9, _hoisted_52)
                        ]),
                        _createElementVNode("td", _hoisted_53, _toDisplayString(_ctx.$filters.dateDisplay(item.purchaseDate)), 1),
                        _createElementVNode("td", _hoisted_54, _toDisplayString(item.noOfLeads), 1),
                        _createElementVNode("td", _hoisted_55, _toDisplayString(item.creditsUsed), 1),
                        _createElementVNode("td", _hoisted_56, [
                          _createElementVNode("button", {
                            class: "btn btn--primary",
                            onClick: ($event: any) => (_ctx.openLeadsReceiptPrint(item.orderId))
                          }, _hoisted_60, 8, _hoisted_57)
                        ]),
                        _createElementVNode("td", _hoisted_61, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.getPurchaseType(item)), 1)
                        ])
                      ]))
                    }), 128)),
                    (_ctx.response.length == 0 && !_ctx.loading)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_62, _hoisted_64))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (_ctx.togglePurchaseCreditModel)
                  ? (_openBlock(), _createBlock(_component_PurchaseCredits, {
                      key: 0,
                      onCancel: _ctx.onCancelPurchase
                    }, null, 8, ["onCancel"]))
                  : _createCommentVNode("", true),
                (_ctx.toggleOpenRefund)
                  ? (_openBlock(), _createBlock(_component_OpenRefund, {
                      key: 1,
                      onCancel: _ctx.onCancelRefund
                    }, null, 8, ["onCancel"]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.toggleReceiptPrintModel)
                ? (_openBlock(), _createBlock(_component_PrintLeadsReceipt, {
                    key: 0,
                    onCloseReceiptPrintModel: _ctx.onCloseReceiptPrintModel
                  }, null, 8, ["onCloseReceiptPrintModel"]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
  ]))
}